import { ICoreZonesInitialState } from "./types";

const initialState: ICoreZonesInitialState  = {
  displayNoFlyZones: true,
  displaySafeLandZones: true,
  hoveredNoFlyZoneId: null,
};

export default initialState;